import React from 'react';

const getFmcsaResponseLabel = (status, responseCode) => {
  if (status === 'success') {
    return 'success';
  }

  if (status === 'fail') {
    if (responseCode === 500) {
      return 'error (500)';
    }
    if (responseCode == null) {
      return 'error';
    }
  }

  return 'declined';
};

export default [
  {
    title: 'Submitted By',
    dataIndex: 'submittedByFirstName',
    key: 'submittedByFirstName',
    width: '200px',
    sorter: true,
    render: (_, { submittedByFirstName, submittedByLastName }) =>
      `${submittedByFirstName} ${submittedByLastName}`
  },
  {
    title: 'Student',
    dataIndex: 'studentFirstName',
    key: 'studentFirstName',
    sorter: true,
    render: (_, { studentFirstName, studentLastName }) => (
      <div style={{ whiteSpace: 'initial' }}>
        {studentFirstName} {studentLastName}
      </div>
    )
  },
  {
    title: 'Contact Number',
    dataIndex: 'contactNumber',
    key: 'contactNumber',
    render: (_, { contactNumber }) => (!contactNumber ? 'N/A' : contactNumber)
  },
  {
    title: 'Submited for',
    dataIndex: 'submittedFor',
    key: 'submittedFor',
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true
  },
  {
    title: 'Submission Date',
    dataIndex: 'submissionDate',
    key: 'submissionDate',
    sorter: true
  },
  {
    title: 'Submission Time',
    dataIndex: 'submissionTime',
    key: 'submissionTime',
    sorter: true
  }
];
